import { useTranslation } from 'react-i18next'

import {
  ProfileActionsWidget,
  useIsProfileWidgetsExpandAvailable,
} from '../../Widget'
import { useNewsboardPostProfileContext } from '../Newsboard.hooks'

import { useNewsboardPostProfileActionsWidgetHandlers } from './NewsboardPostProfileActionsWidget.hooks'
import { getNewsboardPostProfileActionsWidgetItems } from './NewsboardPostProfileActionsWidget.utils'

import * as styles from './NewsboardPostProfileActionsWidget.module.css'

function NewsboardPostProfileActionsWidget({
  className = styles.NewsboardPostProfileActionsWidget,
  isSkeleton,
}) {
  const { t } = useTranslation()

  const { postData } = useNewsboardPostProfileContext()

  const isWidgetsExpandAvailable = useIsProfileWidgetsExpandAvailable()

  const {
    handleClickAction,
    handleSelectServiceRequestOption,
    serviceRequestOptions,
  } = useNewsboardPostProfileActionsWidgetHandlers()

  const actions = getNewsboardPostProfileActionsWidgetItems({
    postData,
    serviceRequestOptions,
    t,
    onSelectServiceRequestOption: handleSelectServiceRequestOption,
  })

  return isSkeleton || actions.length > 0 || isWidgetsExpandAvailable ? (
    <ProfileActionsWidget
      actions={actions}
      className={className}
      isSkeleton={isSkeleton}
      onClickAction={handleClickAction}
    />
  ) : null
}

export default NewsboardPostProfileActionsWidget
